import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Observer } from "rxjs";
import { Country } from "../model/country.enum";
import { EnvironmentService } from "./environment.service";

@Injectable({ providedIn: "root" })
export class CountryService  {

    constructor(
        private httpClient : HttpClient,
        private environmentService : EnvironmentService
    ) { }

    // TODO: 
    //  - Unificar estructura de datos de la informacion
    //  - Armar un factory para este metodo
    //  - Armar un grafo o lista enlazada para la estructura

    public getGrandfather() : Observable<Object> {
        switch(this.environmentService.country){
            case Country.ARGENTINA:
                return this.getArgentineProvinces();
            case Country.URUGUAY:
                return this.getUruguayDeparments();
            default: 
                return this.emptyObjectObservable();
        }
    }

    public getFather() : Observable<Object> {
        switch(this.environmentService.country){
            case Country.ARGENTINA:
                return this.getArgentineLocalities();
            case Country.URUGUAY:
                return this.getUruguayLocalities();
            default: 
                return this.emptyObjectObservable();
        }
    }

    public getSon() : Observable<Object> {
        switch(this.environmentService.country){
            case Country.ARGENTINA:
                return this.getArgentineNeighborhoods();
            case Country.URUGUAY:
                return this.getUruguayNeighborhoods();
            default: 
                return this.emptyObjectObservable();
        }
    }

    public getArgentineProvinces() : Observable<Object> {
        return this.httpClient.get("assets/json/countries/argentina/provincias.json")     
    }

    public getArgentineLocalities() : Observable<Object> {
        return this.httpClient.get("assets/json/countries/argentina/partidos.json")
    }

    public getArgentineNeighborhoods(): Observable<Object> {
        return this.httpClient.get("assets/json/countries/argentina/barrios.json")
    }

    public getUruguayDeparments() : Observable<any> {
        return this.httpClient.get("assets/json/countries/uruguay/departamentos.json")
    }

    public getUruguayLocalities() : Observable<Object> {
        return this.httpClient.get("assets/json/countries/uruguay/localidades.json")
    }

    public getUruguayNeighborhoods(): Observable<Object> {
        return this.emptyObjectObservable();
    }

    private emptyObjectObservable() : Observable<Object> {
        return new Observable((observer: Observer<Object>) => {
            observer.next("");
        })
    }

    /*
     * Devuelve el nombre de la estructura mayor
     * del pais. 
     * TODO: Usar el modulo con @ngx-translate para obtener las
     * traducciones dependiendo la zona en la que se encuentra la 
     * aplicacion, ya sea 'es-AR', 'es-UY', 'en', etc.
     */
    public grandfatherStructureName(): string {
        switch(this.environmentService.country){
            case Country.ARGENTINA:
                return "Provincia"
            case Country.URUGUAY:
                return "Departamento"
            default:
                return "[UNKNOWN]"
        }       
    }
}